import React from 'react';
import { Route } from 'react-router-dom';
import NotificationsCenter from './NotificationsCenter';

export const routes = [<Route key="1" path="/notificationsCenter/:type?" component={NotificationsCenter} />];

export const navigation = [{ name: 'notificationsCenter', link: '/notificationsCenter' }];
